import { Notify } from 'quasar';

interface SnackbarAction {
  label: string;
  handler: () => void
}

function showSuccessSnackBar(message: string, actions?: SnackbarAction[]) {

  Notify.create({
    message,
    actions,
    icon: 'fa-regular fa-circle-check',
    color: 'iosnackbarsuccess',
    textColor: 'iosnackbarsuccess',
    iconColor: 'iosnackbariconsuccess',
    position: 'bottom-right',
    classes: 'io-mfe-ig-snackbar io-mfe-ig-snackbar-success',
    timeout: 4000
  });
}

export {SnackbarAction, showSuccessSnackBar}